export interface ProductCategory {
  id: number;
  description: string;
  code: string;
}

/**
 * Determina o nome do canal baseado nos filtros de oferta ativos
 * @param offerTypes Array de tipos de oferta selecionados
 * @param categories Array de IDs de categorias selecionadas
 * @param productCategories Array completo de categorias disponíveis
 * @param pathname URL atual da aplicação
 * @returns Nome do canal a ser exibido
 */
export const getChannelName = (
  offerTypes: string[] = [],
  categories: number[] = [],
  productCategories: ProductCategory[] = [],
  pathname = '',
): string => {
  if (pathname.includes('/my-offers')) {
    return 'Ofertas exclusivas';
  }

  if (categories.length === 1) {
    const selectedCategory = productCategories.find(
      (cat) => cat.id === categories[0],
    );
    if (selectedCategory) {
      return selectedCategory.description;
    }
  }

  if (categories.length > 1) {
    return 'Múltiplas categorias';
  }

  const lengthItems = offerTypes.length;

  const isLkpOnly =
    lengthItems > 0 &&
    offerTypes.every(
      (offerType) => offerType === 'inTransit' || offerType === 'received',
    );

  if (isLkpOnly) {
    return 'LKP';
  }

  if (offerTypes.includes('onSite') && lengthItems === 1) {
    return 'Estoque no Produtor';
  }

  if (offerTypes.includes('directed') && lengthItems === 1) {
    return 'Ofertas direcionadas';
  }

  return 'Todas as ofertas';
};
